export class ViewState {
    constructor() {
        this.CellSize = 0;
        this.Ratio = 1;
        this.Img_bk_loaded = false;
        this.Img_bk = new Image();
        this.mouse_x = 0;
        this.mouse_y = 0;
        this.isTouch = true;
        this.message = '';
        this.demo = true;
        this.demo_inc = 0;
        this.autoLog = false;
    }
}
